;(function () {
    const comps = document.querySelectorAll('.template--superposed-middle:not(.o-about-crafting)');
    if (!comps.length) return;

    if (typeof ScrollTrigger === 'undefined') {
        console.warn('ScrollTrigger est manquant');
        return;
    }

    comps.forEach((comp) => {
        ScrollTrigger.create({
            trigger: comp,
            start: 'center center',
            end: 'bottom top',
            pin: true,
            pinSpacing: false,
        });
    });
})();
